import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { onboardingEntryPath } from '../../onboarding/onboardingSteps'
import { isSupabaseConfigured, readStoredAccessToken } from '../../lib/supabaseSessionStorage'

function runWhenIdle(fn: () => void): () => void {
  if (typeof requestIdleCallback === 'function') {
    const id = requestIdleCallback(fn, { timeout: 3000 })
    return () => cancelIdleCallback(id)
  }
  const id = window.setTimeout(fn, 1)
  return () => clearTimeout(id)
}

/** After first paint, redirect logged-in users without blocking landing LCP. */
export function LandingAuthRedirect() {
  const navigate = useNavigate()

  useEffect(() => {
    let cancelled = false

    const cancelIdle = runWhenIdle(() => {
      void (async () => {
        if (cancelled || !isSupabaseConfigured()) return

        const token = readStoredAccessToken()
        if (!token) return

        try {
          const res = await fetch('/api/auth/session', {
            headers: { Authorization: `Bearer ${token}` },
          })
          if (!res.ok || cancelled) return
          const session = (await res.json()) as {
            authenticated?: boolean
            onboardingCompleted?: boolean
          }
          if (!session.authenticated) return
          navigate(session.onboardingCompleted ? '/status' : onboardingEntryPath(), {
            replace: true,
          })
        } catch {
          // Ignore — visitor sees the landing page
        }
      })()
    })

    return () => {
      cancelled = true
      cancelIdle()
    }
  }, [navigate])

  return null
}
